module.exports = __webpack_public_path__ + "static/media/walkthroughCustomize.7347b32b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/guestlist/walkthroughCustomize.mp4
// module id = 2367
// module chunks = 71